import type { ChatContactUser } from '@/components/Messenger/sidebar/ChatSidebar';
import { getUserDisplayName } from '@/components/Messenger/sidebar/ChatSidebar';

/** Поиск по отображаемому имени, частям ФИО и должности (поле `role` на сервере). */
export function matchesChatContactSearchQuery(u: ChatContactUser, qLower: string): boolean {
  if (!qLower) return true;
  const name = getUserDisplayName(u).toLowerCase();
  const role = (u.role ?? '').trim().toLowerCase();
  const fn = (u.first_name ?? '').trim().toLowerCase();
  const ln = (u.last_name ?? '').trim().toLowerCase();
  const nm = (u.name ?? '').trim().toLowerCase();
  return (
    name.includes(qLower) ||
    role.includes(qLower) ||
    fn.includes(qLower) ||
    ln.includes(qLower) ||
    (nm.length > 0 && nm.includes(qLower))
  );
}
